/**
 * The words for "which arche these files belong to", shared by the storage
 * breakdown and the workspace's By Arche view so the same files are never
 * named two different ways.
 *
 * An arche's name can be contributor-authored, so it is scrubbed before
 * display. Files with no arche (`source_arche_id` NULL) mean two different
 * things depending on where they sit: outside Arche Saves they are a
 * person's uploads (their own, or files given to an arche in My-Fias);
 * inside Arche Saves they are deliveries the platform made.
 */
import { scrubForDisplay } from '@/components/files/file-dialog/display-safety';
import type { VaultArea } from '@/lib/vault-areas';

export const ARCHE_LABEL_MAX = 60;

/** Label for a group of files by the arche that made them. `area` only
 *  matters when there is no arche. */
export function archeLabel(
  entry: { archeId: string | null; archeName: string | null },
  area: VaultArea,
): string {
  if (entry.archeName) return scrubForDisplay(entry.archeName, ARCHE_LABEL_MAX);
  if (entry.archeId === null) return noArcheLabel(area);
  return 'An arche that’s no longer available';
}

/** The label for files no arche made, by where they sit. */
export function noArcheLabel(area: VaultArea): string {
  if (area === 'arche-saves') return 'Fias';
  if (area === 'my-fias') return 'Files you gave arches';
  return 'Uploaded by you';
}
